import React from "react";
import "./App.css";
import { Route, Routes } from "react-router-dom";
import { publicRoutes } from "./routes";
import NonAuthLayout from "./components/NonAuthLayout";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { NotificationProvider } from "./components/Header/NotificationContext";

function App() {
  const queryClient = new QueryClient({
    defaultOptions: {},
  });
  return (
    <React.Fragment>
      <QueryClientProvider client={queryClient}>
        <NotificationProvider>
          <Routes>
            {publicRoutes.map((route, idx) => (
              <Route
                path={route.path}
                element={
                  <NonAuthLayout>
                    {React.createElement(route.component)}
                  </NonAuthLayout>
                }
                key={idx}
              />
            ))}
          </Routes>
        </NotificationProvider>
      </QueryClientProvider>
    </React.Fragment>
  );
}

export default App;
